<template>
   <!-- <div> -->
   <v-app-bar id="home-app-bar" app height="80" style="box-shadow: 0 1px 1px -1px rgba(0,0,0,.32);">
      <v-avatar :rounded="!$store.state.user.Face" size="48" class="mr-3" :class="{ 'invert': !$store.state.global.Logo }">
         <v-img :src="logoOrFace" :contain="!$store.state.user.Face" />
      </v-avatar>
      <v-list-item-content class="ml-2">
         <v-list-item-title class="font-weight-bold">
            {{ this.$store.state.zone ? `${$store.state.global.code} — ${$store.state.global.title}` : '' }}
         </v-list-item-title>
         <v-list-item-subtitle v-if="$store.getters.isLoggedIn">
            {{ `${$store.state.user.name} ( ${$store.state.user.code} )` }}
         </v-list-item-subtitle>
         <v-list-item-subtitle v-else>
            {{ this.$store.state.zone ? $store.state.global.wisdom : '' }}
         </v-list-item-subtitle>
      </v-list-item-content>
      <div>
         <v-tabs optional background-color="transparent" @change="reset">
            <!-- class="hidden-sm-and-down" -->
            <v-tab v-for="(category, idx) in filteredCategories" :key="idx" :to="category.link" :exact="category.link === '/'" :ripple="false"
               class="font-weight-bold px-5 text-uppercase" min-width="96" text>
               <!-- :disabled="!category.auth" -->
               <v-badge :value="![undefined, ''].includes(categoryBadge(category.text))" :dot="zeroBadge(categoryBadge(category.text))"
                  :content="countBadge(categoryBadge(category.text))" color="rgb(255, 0, 0, .95)" :offset-y="zeroBadge(categoryBadge(category.text)) ? 3 : 7"
                  :offset-x="zeroBadge(categoryBadge(category.text)) ? 3 : 7">
                  {{ category.text }}
               </v-badge>
            </v-tab>
         </v-tabs>
      </div>
      <template v-if="$store.getters.isLoggedIn">
         <v-badge :value="clients" :content="clients" color="rgb(255, 0, 0, .95)" offset-x="22" offset-y="18">
            <v-icon large class="mx-3">mdi-account-multiple</v-icon>
         </v-badge>
         <v-menu left bottom>
            <template v-slot:activator="{ on, attrs }">
               <v-badge :value="![undefined, ''].includes(categoryBadge('Options'))" :dot="zeroBadge(categoryBadge('Options'))"
                  :content="countBadge(categoryBadge('Options'))" color="rgb(255, 0, 0, .95)" :offset-y="zeroBadge(categoryBadge('Options')) ? 18 : 22"
                  :offset-x="zeroBadge(categoryBadge('Options')) ? 12 : 16">
                  <v-btn large icon v-bind="attrs" v-on="on">
                     <v-icon>mdi-dots-vertical</v-icon>
                  </v-btn>
               </v-badge>
            </template>
            <v-list>
               <template v-for="(menu, idx) in menus">
                  <v-divider v-if="menu.divider" :key="`v-divider-${idx}`" inset class="mx-0" style="max-width: 100%;" />
                  <v-list-item v-else v-show="!menu.auth || Object.keys($store.state.user).some(s => menu.auth.includes(s))" :key="`v-list-item-${idx}`"
                     @click="command(menu)">
                     <v-list-item-icon>
                        <v-icon>{{ menu.icon }}</v-icon>
                     </v-list-item-icon>
                     <v-list-item-title>{{ menu.text }}</v-list-item-title>
                  </v-list-item>
               </template>
            </v-list>
         </v-menu>
      </template>

      <v-alert :value="kind !== 'Normal' && !!note" dark dismissible width="calc(100% - 30px)" class="my-2" style="position: absolute;"
         :border="kind === 'Success' ? 'left' : 'top'" :colored-border="kind === 'Success'"
         :type="kind === 'Success' ? 'success' : kind === 'Alert' ? 'warning' : 'error'" :color="kind === 'Alert' ? 'orange darken-2' : ''"
         @input="$store.commit('clearMessage')">
         {{ note }}
      </v-alert>
      <v-snackbar :value="kind === 'Normal' && note" top class="mt-2">
         {{ note }}
      </v-snackbar>
   </v-app-bar>
   <!-- </div> -->
</template>

<script>
import { imageFromUrl } from '@/utils/nirtara'
import { roles } from '@/utils/roles'
export default {
   name: 'HomeAppBar',

   props: {
      badge: { type: Object },
      clients: { type: Number, default: 0 },
   },
   data: () => ({
      // message: { Message: [{ Error: [], note: '' }], kind: '' },
      kind: '',
      note: '',
      categories: [
         { text: 'Home', link: '/', auth: [] },
         { text: 'Development', link: '/docs/development', auth: ['development'] },
         { text: 'Operation', link: '/docs/operation' },
         { text: 'Programming', link: '/docs/programming' },
         { text: 'Persons', link: '/persons', auth: roles.filter(j => j.type === 'Person').map(j => j.kind.toLowerCase()) },
         { text: 'Locations', link: '/locations', auth: roles.filter(j => j.type === 'Location').map(j => j.kind.toLowerCase()) },
         { text: 'Subjects', link: '/subjects', auth: roles.filter(j => j.type === 'Subject').map(j => j.kind.toLowerCase()) },
         { text: 'Activities', link: '/activities', auth: roles.filter(j => j.type === 'Activity').map(j => j.kind.toLowerCase()) },
      ],
      menus: [
         { text: 'Profile', icon: 'mdi-account', link: '/profile', auth: ['profile'] },
         { text: 'Settings', icon: 'mdi-hammer-screwdriver', link: '/settings', auth: ['setting'] },
         { divider: true },
         { text: 'Logout', icon: 'mdi-logout', link: '/' },
      ],
   }),
   computed: {
      logoOrFace() {
         if (this.$store.getters.isLoggedIn && this.$store.state.user.Face) return imageFromUrl(this.$store.state.user.Face)
         return this.$store.state.global.Logo ? imageFromUrl(this.$store.state.global.Logo) : require('@/assets/logo.svg')
      },
      filteredCategories() {
         return this.categories.filter(category => {
            if (this.$store.getters.isLoggedIn) {
               return category.auth && (!category.auth.length || Object.keys(this.$store.state.user).some(s => category.auth.includes(s)))
            } else {
               return !category.auth || !category.auth.length
            }
         })
      },
      categoryBadge() {
         return text => this.badge[text.toLowerCase()]
      },
      countBadge() {
         return number => {
            return number < -9 ? '9-' : number > 9 ? '9+' : `${number}`
         }
      },
      zeroBadge() {
         return number => {
            return number === 0
         }
      },
   },

   watch: {
      '$store.state.message.Message.0.note'(note) {
         this.note = note
         if (!note) return
         const timeout = this.$store.state.message.timeout
         this.kind = this.$store.state.message.kind
         if (this.kind === 'Normal' || timeout) setTimeout(() => { this.note = ''; this.$store.commit('clearMessage') }, timeout || 4000)
      },
   },
   created() {
      // console.log(`created ( browser = ${this.$store.state.browser}, ipV4 = ${this.$store.state.ipV4} => ${process.env.NODE_ENV} )`)
      // const idx = this.categories.findIndex(j => j.link === '/')
      // process.env.NODE_ENV === 'development' && this.categories.splice(idx + 1, 0, { text: 'Development', link: '/docs/development' })
   },
   mounted() {
   },
   methods: {
      command(menu) {
         switch (menu.text) {
            default: this.$route.path !== menu.link && this.$router.push({ path: menu.link })
               menu.text === 'Settings' && this.reset('/options')
               break
            case 'Logout':
               this.$store.dispatch('logout', this.$store.state.user).then(() => this.$route.path !== menu.link && this.$router.push({ path: menu.link }))
               break
         }
      },
      reset(link) {
         if (!link) return
         const key = link.replace(/(?![a-z])./g, '')
         this.badge[key] !== undefined && (this.badge[key] = '')
      },
   },
}
</script>

<style lang="sass">
#home-app-bar
   .v-tabs-slider
      max-width: 24px
      margin: 0 auto
   .v-tab
      &::before
         display: none
   .v-tabs-bar
      height: 44px
   .invert
      filter: invert(1)
</style>

<style lang="scss" scoped>
.v-application--is-ltr .v-list-item__icon:first-child {
   margin-right: 16px;
}
</style>